/**
 * Sajtens nyckeltal (antal elavtal och elbolag) räknas fram i
 * getHomeStats() ur avtalsflödet (agreement_feed_items, privatavtal) – det är
 * den enda källan. Alla texter som nämner siffrorna (startsidan, /elavtal,
 * /for-llms, /llms.txt) formaterar dem här, avrundade nedåt så att "över"
 * alltid stämmer.
 */
/** Samma fält som HomeStats i homeStats.functions.ts, men valfria. */
export interface StatsInput {
  agreementCount?: number | null | undefined;
  companyCount?: number | null | undefined;
}

export const AGREEMENT_STEP = 100;
export const COMPANY_STEP = 10;

/** Avrundar nedåt till `step` och formaterar på svenska ("9 600"), eller "" om värdet saknas. */
export function formatStatCount(n?: number | null, step = 1): string {
  if (n == null || n <= 0) return "";
  const rounded = Math.floor(n / step) * step;
  if (rounded <= 0) return "";
  return new Intl.NumberFormat("sv-SE").format(rounded);
}

/** Avrundade nyckeltal, eller null om statistiken inte gick att hämta. */
export function statFigures(
  stats?: StatsInput | null,
): { agreements: string; companies: string } | null {
  const agreements = formatStatCount(stats?.agreementCount, AGREEMENT_STEP);
  const companies = formatStatCount(stats?.companyCount, COMPANY_STEP);
  return agreements && companies ? { agreements, companies } : null;
}

/**
 * "över 9 600 elavtal från över 120 elbolag", eller en formulering utan
 * siffror när statistiken saknas (hellre det än en gammal siffra).
 */
export function agreementsPhrase(stats?: StatsInput | null): string {
  const f = statFigures(stats);
  return f
    ? `över ${f.agreements} elavtal från över ${f.companies} elbolag`
    : "elavtal från Sveriges elbolag";
}
